import { useEffect, useState } from 'react';

function CheckBox(props) {
	const [checkedList, setCheckedList] = useState([]);
	const [IsAllChecked, setIsAllChecked] = useState(false);

	const handleIsAllChecked = (comparisonList) => {
		const newComparisonList = comparisonList;
		if (props.isAllCheck && props.itemList && props.itemList.length) {
			props.itemList.length !== newComparisonList.length ? setIsAllChecked(false) : setIsAllChecked(true);
		}
	};

	const handleAllCheck = (checked) => {
		const newArray = [];
		if (checked) {
			props.itemList.forEach((el) => newArray.push(el));
			setCheckedList(newArray);
			props.getCheckedList(newArray);
		} else {
			setCheckedList(newArray);
			props.getCheckedList(newArray);
		}
		handleIsAllChecked(newArray);
	};
	const checkedItemHandler = (value, isChecked) => {
		let newCheckedList = [];

		if (isChecked) {
			newCheckedList = checkedList ? [...checkedList, value] : [value];
		}
		if (!isChecked && checkedList && checkedList.includes(value)) {
			newCheckedList = checkedList.filter((item) => item !== value);
		}
		setCheckedList(newCheckedList);
		props.getCheckedList(newCheckedList);
		handleIsAllChecked(newCheckedList);
		return;
	};

	const checkHandler = (e, value) => {
		let newValue = value;
		checkedItemHandler(newValue, e.target.checked);
	};

	useEffect(() => {
		let updatedList = [];
		if (props.updateList && props.updateList.length > 0) {
			updatedList = props.updateList;
			setCheckedList(updatedList);
		} else {
			setCheckedList(updatedList);
		}
		handleIsAllChecked(updatedList);
	}, [props.updateList]);

	useEffect(() => {
		let newDefaultCheckedList = [];
		if (props.defaultCheckedList && props.defaultCheckedList.length) {
			newDefaultCheckedList = props.defaultCheckedList;
			setCheckedList(newDefaultCheckedList);
		}
		props.isAllCheck ??
			setTimeout(() => {
				handleIsAllChecked(newDefaultCheckedList);
			}, 100);
	}, []);

	return (
		<div className='checkbox'>
			{props.isAllCheck && (
				<div className='checkboxItem'>
					<label>
						<input type='checkbox' checked={IsAllChecked} onChange={(e) => handleAllCheck(e.target.checked)} value='' />
						전체
					</label>
				</div>
			)}
			{props.itemList.map((item, index) => {
				if (item === 'SALE') {
					return (
						<div className='checkboxItem' key={index}>
							<label className='sale'>
								<input
									type='checkbox'
									id={index}
									checked={checkedList?.includes(item)}
									onChange={(e) => checkHandler(e, e.target.value)}
									value={item || ''}
									style={{ marginRight: '100' }}
								/>
								<span>{props?.parseStatus ? props.parseStatus(item) : item}</span>
							</label>
						</div>
					);
				} else {
					return (
						<div className='checkboxItem' key={index}>
							<label>
								<input
									type='checkbox'
									id={index}
									checked={checkedList?.includes(item)}
									onChange={(e) => checkHandler(e, e.target.value)}
									value={item || ''}
								/>
								<span>{props?.parseStatus ? props.parseStatus(item) : item}</span>
							</label>
						</div>
					);
				}
			})}
		</div>
	);
}

export default CheckBox;
